import { InscritoNotificacao, PapelNotificacao, PessoaElegivelNotificacao, PessoaNotificacao, PracaNotificacao } from '../../../../types/estoque'
import { paraBusca } from '../formato'

export const PAPEL_ROTULO: Record<PapelNotificacao, string> = {
  ATENDIMENTO: 'Atendimento',
  REMESSAS: 'Remessas',
}

export const PAPEL_DESCRICAO: Record<PapelNotificacao, string> = {
  ATENDIMENTO: 'Solicitação nova, resposta do solicitante quando ninguém assumiu o pedido e cancelamento.',
  REMESSAS: 'Coleta, chegada e conferência de remessas.',
}

export const REGRA_PADRAO =
  'Sem ninguém configurado, vale a regra padrão: quem tem Atender com esta praça no cadastro e, se não houver, quem atende todas as praças.'

export interface PessoaDoEditor extends PessoaNotificacao {
  marcada: boolean
  apta: boolean
  inativa: boolean
  todasAsPracas: boolean
}

export interface EntradaDoEditor {
  pessoas: PessoaElegivelNotificacao[]
  aptos: number[]
  inscritos: InscritoNotificacao[]
  marcados: number[]
  busca: string
  nomes: Record<number, string>
}

export function pessoasDoEditor(e: EntradaDoEditor): PessoaDoEditor[] {
  const porId = new Map<number, PessoaDoEditor>()
  for (const p of e.pessoas) {
    if (e.aptos.indexOf(p.id) < 0) continue
    porId.set(p.id, { id: p.id, nome: p.nome, semEmail: p.semEmail, todasAsPracas: p.todasAsPracas, marcada: false, apta: true, inativa: false })
  }
  for (const i of e.inscritos) {
    if (porId.has(i.id)) continue
    porId.set(i.id, { id: i.id, nome: i.nome, semEmail: i.semEmail, todasAsPracas: false, marcada: false, apta: !i.semAcesso, inativa: i.inativo })
  }
  for (const id of e.marcados) {
    if (porId.has(id)) continue
    porId.set(id, { id, nome: e.nomes[id] ?? `Pessoa ${id}`, semEmail: false, todasAsPracas: false, marcada: false, apta: false, inativa: false })
  }
  const termo = paraBusca(e.busca)
  return Array.from(porId.values())
    .map((p) => ({ ...p, marcada: e.marcados.indexOf(p.id) >= 0 }))
    .filter((p) => p.marcada || !termo || paraBusca(p.nome).indexOf(termo) >= 0)
    .sort((a, b) => {
      if (a.marcada !== b.marcada) return a.marcada ? -1 : 1
      return a.nome.localeCompare(b.nome, 'pt-BR')
    })
}

export function nomesConhecidos(pessoas: PessoaNotificacao[], inscritos: PessoaNotificacao[]): Record<number, string> {
  const nomes: Record<number, string> = {}
  for (const p of pessoas.concat(inscritos)) nomes[p.id] = p.nome
  return nomes
}

export function alternar(marcados: number[], id: number): number[] {
  return marcados.indexOf(id) >= 0 ? marcados.filter((x) => x !== id) : marcados.concat(id)
}

export function mesmaLista(a: number[], b: number[]): boolean {
  if (a.length !== b.length) return false
  const conjunto = new Set(a)
  return b.every((x) => conjunto.has(x))
}

export function impedimentoSalvar(marcados: number[], atuais: number[], aptos: number[], max: number): string | null {
  if (mesmaLista(marcados, atuais)) return 'Nada mudou.'
  if (marcados.length > max) return `No máximo ${max} pessoas por praça.`
  if (marcados.some((id) => aptos.indexOf(id) < 0)) return 'Tire da lista quem está sem acesso a esta praça para salvar.'
  return null
}

export function avisosDoInscrito(i: InscritoNotificacao): string[] {
  const avisos: string[] = []
  if (i.inativo) avisos.push('usuário inativo')
  else if (i.semAcesso) avisos.push('sem acesso a esta praça')
  if (i.semEmail) avisos.push('sem e-mail')
  return avisos
}

export type SituacaoDaPraca = 'REGRA_PADRAO' | 'COM_AVISOS' | 'CONFIGURADA'

export function situacaoDaPraca(praca: PracaNotificacao): SituacaoDaPraca {
  if (!praca.papeis.length || praca.papeis.some((p) => p.usaRegraPadrao)) return 'REGRA_PADRAO'
  if (praca.papeis.some((p) => p.inscritos.some((i) => !i.recebe))) return 'COM_AVISOS'
  return 'CONFIGURADA'
}
